import { AddressForm } from '@/types/form';
import { User } from '@/types/user';

import { getPermanentAddressFromUser } from '@/utils/address';

import { UpdatePersonalInfo } from '../types';

export function updatePersonalInfoFormToAddressFormForMailing(
  form: Omit<Partial<UpdatePersonalInfo>, 'employmentDetailed'>,
  user: User,
): AddressForm {
  const addr = form.addressDetailed || {
    line1: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  };
  const permanentSource = getPermanentAddressFromUser(user);

  return {
    line1: addr.line1,
    city: addr.city,
    state: addr.state,
    zip: addr.zip,
    country: addr.country,
    differentTaxResidency: false,
    residence: permanentSource?.residence ?? ('' as AddressForm['residence']),
    poBox: permanentSource?.poBox,
    poBoxDistrict: permanentSource?.poBoxDistrict,
    mailingSameAsResidential: form.mailingSameAsResidential ?? true,
    mailingLine1: form.mailingLine1 ?? '',
    mailingCity: form.mailingCity ?? '',
    mailingState: form.mailingState ?? '',
    mailingZip: form.mailingZip ?? '',
    mailingCountry: form.mailingCountry ?? '',
    residenceCountry: form.residenceCountry,
  };
}
